

import store from '../store'
import Request from './request'
import i18n from '@/i18n';
// Self-made Snackbar
import snackbar from '@/plugins/snackbar';

async function fetch(id,data){
    return Request("get","api/receipt?supplier_id="+id,data)
}

async function fetchOne(id,data){
    return Request("get","api/receipt/"+id,data)
}

// 批量导出
async function exportBatchExcel(id,data){
    store.dispatch("fullscreenLoading");
    const response = await Request('get', "api/receipt/supplier-receipt-export?supplier_id=" + id, data);
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t("Export.recordedHint"));
    }
    store.dispatch("fullscreenLoadingStop");
    return response;
}

async function exportOne(id){
    store.dispatch("fullscreenLoading");
    const response = await Request('get','api/receipt/supplier-bill-detail-export?id=' + id)
    if(response.data && response.data.status.isOK()){
        snackbar.info(i18n.t("Export.recordedHint"))
    }
    store.dispatch("fullscreenLoadingStop");
    return response
}


export default {
    fetch,
    fetchOne,
    exportBatchExcel,
    exportOne
}